import createComponent from '@carvana/merch-components/createComponent';
import { TranslucentCard } from '../Hero.styles';

export const DesktopCard = createComponent(TranslucentCard, {
  className:
    'grid grid-cols-[1fr_auto] content-center items-center gap-y-md rounded-md px-xl py-lg text-text-inverse t-heading-sm md:p-2xl',
  rounded: 'md'
});

export const TabletCard = createComponent(TranslucentCard, {
  className: 'rounded-md px-xl py-lg text-text-inverse t-heading-md',
  rounded: 'lg'
});
